module.exports = __webpack_public_path__ + "assets/img/5_1371_big.4ca0f5c2.jpg";